/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ path: NonNullable<unknown> }} Chat_Save_To_Space_PathInputs */



/**
* | output |
* | --- |
* | "Path: {path}" |
*
* @param {Chat_Save_To_Space_PathInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_save_to_space_path = /** @type {((inputs: Chat_Save_To_Space_PathInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Save_To_Space_PathInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Pfad: ${i?.path}`)
	return /** @type {LocalizedString} */ (`Path: ${i?.path}`)
});